import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import Thumbnail from 'components/thumbnail';
import createTransformSourceGravatar from 'utils/gravatar';
import setInnerHTML from 'utils/setInnerHTML';
import { COAUTHOR_SHAPE } from 'config/types/prop';

import styles from './authorHeader.css';

const AuthorHeader = ({
  displayName,
  descriptions,
  description,
  avatarUrl,
  currentEdition,
}) => (
  <section>
    <div className={styles.authorHeader}>
      <div className={styles.photoContainer}>
        <Thumbnail
          alt="Author Headshot"
          height="140"
          originalSource={avatarUrl}
          position="authorHeader"
          transformFactory={createTransformSourceGravatar}
          width="140"
          wrapperClasses={styles.photo}
        />
      </div>
      <div className={styles.textContainer}>
        <div className={styles.authorName}>{displayName}</div>
        <div
          className={styles.description}
          dangerouslySetInnerHTML={setInnerHTML( // eslint-disable-line react/no-danger
            descriptions[currentEdition] || description,
          )}
        />
      </div>
    </div>
  </section>
);

AuthorHeader.propTypes = COAUTHOR_SHAPE;

const wrapWithStyles = withStyles(styles);

export default wrapWithStyles(AuthorHeader);
